import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    app: "61661857b8ec3f001295f8db",
    user: null,
    token: null,
    refreshToken: null,
  },
  mutations: {
    setApp(state, app) {
      state.app = app;
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token, refreshToken) {
      state.token = token;
    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken;
    },
    signOut(state){
      state.user =null;
      state.token = null;
      state.refreshToken = null;
    }
  },
  actions: {},
  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },
  },
  plugins: [createPersistedState({
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: true }),
      removeItem: key => Cookies.remove(key)
    }
  })],
});
